// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__MRyqs","options":"AnswerScale_options__1w6Ug","selected":"AnswerScale_selected__il9Cs"};